export default __webpack_public_path__ + "static/media/google-icon.9e560710.svg";